import { render } from "./XIcon.vue?vue&type=template&id=0cd5332b&scoped=true"
import script from "./XIcon.vue?vue&type=script&lang=js"
export * from "./XIcon.vue?vue&type=script&lang=js"

import "./XIcon.vue?vue&type=style&index=0&id=0cd5332b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd5332b"]])

export default __exports__